import TaraIcon from '../../assets/images/tara.svg';

const SPARKLES = [
  { size: 10, top: '-6%', left: '18%', delay: '0s', duration: '2s' },
  { size: 6, top: '8%', left: '90%', delay: '0.5s', duration: '1.7s' },
  { size: 7, top: '80%', left: '92%', delay: '0.9s', duration: '2.2s' },
  { size: 5, top: '95%', left: '25%', delay: '1.3s', duration: '1.9s' },
  { size: 6, top: '50%', left: '-8%', delay: '0.3s', duration: '2.1s' },
];

const Sparkle = ({ size, top, left, delay, duration }: (typeof SPARKLES)[number]) => (
  <svg
    className="absolute animate-[twinkle_ease-in-out_infinite]"
    style={{
      top,
      left,
      width: size,
      height: size,
      animationDelay: delay,
      animationDuration: duration,
    }}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 0C12 6.5 12.5 10 13.5 11.5C15 12.5 18.5 13 24 13C18.5 13 15 13.5 13.5 14.5C12.5 16 12 19.5 12 24C12 19.5 11.5 16 10.5 14.5C9 13.5 5.5 13 0 13C5.5 13 9 12.5 10.5 11.5C11.5 10 12 6.5 12 0Z"
      fill="url(#sparkleGradient)"
    />
    <defs>
      <linearGradient id="sparkleGradient" x1="0" y1="0" x2="24" y2="24">
        <stop offset="0%" stopColor="#6E3EF5" />
        <stop offset="100%" stopColor="#A818D8" />
      </linearGradient>
    </defs>
  </svg>
);

const Screenloader = () => {
  return (
    <div className="h-[100vh] w-full flex items-center justify-center bg-white">
      <div className="relative h-20 w-20 flex items-center justify-center">
        {/* Sparkles */}
        {SPARKLES.map((s, i) => (
          <Sparkle key={i} {...s} />
        ))}

        {/* Outer ring */}
        <div
          className="absolute h-14 w-14 rounded-full animate-[spin_1.4s_linear_infinite]"
          style={{
            background:
              'conic-gradient(from 0deg, transparent 0%, #6E3EF5 50%, #A818D8 100%)',
            WebkitMask:
              'radial-gradient(farthest-side, transparent calc(100% - 3px), #000 calc(100% - 3px))',
            mask: 'radial-gradient(farthest-side, transparent calc(100% - 3px), #000 calc(100% - 3px))',
          }}
        />

        {/* Inner ring */}
        <div
          className="absolute h-9 w-9 rounded-full animate-[spin_1.8s_linear_infinite_reverse]"
          style={{
            background:
              'conic-gradient(from 180deg, transparent 0%, #A818D8 50%, #6E3EF5 100%)',
            WebkitMask:
              'radial-gradient(farthest-side, transparent calc(100% - 3px), #000 calc(100% - 3px))',
            mask: 'radial-gradient(farthest-side, transparent calc(100% - 3px), #000 calc(100% - 3px))',
          }}
        />

        {/* Icon */}
        <img
          src={TaraIcon}
          alt="Tara"
          className="relative h-7 w-7 animate-[breathe_1.8s_ease-in-out_infinite]"
        />
      </div>

      <style>{`
        @keyframes breathe {
          0%, 100% { transform: scale(0.92); opacity: 0.75; }
          50% { transform: scale(1.05); opacity: 1; }
        }
        @keyframes twinkle {
          0%, 100% { transform: scale(0.4) rotate(0deg); opacity: 0.15; }
          50% { transform: scale(1) rotate(20deg); opacity: 1; }
        }
      `}</style>
    </div>
  );
};

export default Screenloader;